module.exports = __webpack_public_path__ + "img/sites_white.774f0b71.svg";